import {EMAIL} from './contact';

const utmSource = new URL(window.location.href).searchParams.get('utm_source');
const registerInvite = new URL(window.location.href).searchParams.get('register_invite');

let query = '';
let imgTrans = `https://xiangjifanyi.com/console/workspace`;
const registerInviteUrl = `https://xiangjifanyi.com/console/register-invite/${registerInvite}`;

// 添加第一个参数
if (utmSource) {
  query = `?utm_source=${utmSource}`;
  imgTrans = `https://xiangjifanyi.com/console/workspace?utm_source=${utmSource}`;
}

// 添加第二个参数
if (registerInvite) {
  // 如果已经有参数使用 &，否则使用 ?
  query += query ? `&register_invite=${registerInvite}` : `?register_invite=${registerInvite}`;
  imgTrans = `https://xiangjifanyi.com/console/register-invite/${registerInvite}`;
}

// console.log(1111111111, utmSource, query);

// Internal URLs
export const ROUTES = {
  // 历史命名：aboutUsEn 的 En 后缀已无实际意义（多语言 URL 体系下为默认中文路径）
  aboutUsEn: '/about-us',
  analytics: '/analytics',
  apiDoc: '/api-doc',
  apps: '/apps',
  assets: '/assets',
  bounties: '/bounties',
  contact: '/contact',
  createAccount: '/create-account',
  deliveryPolicy: '/delivery-policy',
  deploymentGuide: '/deployment-guide',
  donate: '/donate',
  download: '/download',
  erp: '/erp',
  extension: '/extension',
  faq: '/faq',
  fusion: '/product-image',
  guide: '/guide',
  guidelines: '/guidelines',
  home: '/',
  imageTranslator: '/image-translator',
  language: '/language',
  listingImages: '/listing-images',
  marketing: '/digital-marketing',
  openings: '/openings',
  price: '/pricing',
  privacyPolicy: '/privacy-policy',
  proxyMechanism: '/proxy-mechanism',
  returnPolicy: '/return-policy',
  roadmap: '/roadmap',
  signin: 'sign-in',
  signout: '/sign-out',
  social: '/social',
  styleGuide: '/style-guide',
  subscriptionAgreement: '/subscription-agreement',
  teams: '/teams',
  termsOfService: '/terms-of-service',
  termsOfUse: '/terms-of-use',
  useApi: '/useApi',
  users: '/users',
  useWeb: '/useWeb',
  videoTranslator: '/video-translator',
  wallet: '/wallet',
  walletProgress: '/wallet-progress',
};

// External URLs
const developerPortalUrl = 'https://developer.thenewboston.com';

export const URLS = {
  apps: {},
  blog: 'https://blog.thenewboston.com',
  blogUrl: 'https://xiangjifanyi.com/blog',
  contact: `mailto:${EMAIL}`,
  detailPage: `https://www.xiangjifanyi.com/workspace/ecommerce-listing-images${query}`, // 新 workspace（2026-09-16，原 /detail-page/）
  developerAPIDoc: `https://openapi-doc.xiangjifanyi.com/`, // Apifox 新文档（导航 API 对接用，业务确认保留外链）
  developerPortal: {
    api: `${developerPortalUrl}/api`,
    home: developerPortalUrl,
    nodeDeployment: `${developerPortalUrl}/node-deployment`,
    projects: `${developerPortalUrl}/projects`,
    sdkAndLibraries: `${developerPortalUrl}/sdks-and-libraries`,
    tutorials: `${developerPortalUrl}/tutorials`,
    utilities: `${developerPortalUrl}/utilities`,
    whitepaper: `${developerPortalUrl}/whitepaper`,
  },
  fusionWorkspace: `https://www.xiangjifanyi.com/workspace/ai-model-photos${query}`, // 新 workspace（2026-09-16，原 /fusion/workspace）
  imgKoutu: `https://xiangjifanyi.com/console/workspace/koutu${query}`,
  imgLink: `https://xiangjifanyi.com/console/workspace/image-link${query}`,
  // imgTrans: `https://xiangjifanyi.com/console/workspace${query}`,
  imgTrans,

  imgWaterMark: `https://xiangjifanyi.com/console/user/setting${query}`,
  jingxiuDoc: `https://xiangjifanyi.com/doc/jingxiuDoc${query}`,
  login: `https://www.xiangjifanyi.com/workspace/${query}`,
  registerInviteUrl,
  videoTrans: `https://xiangjifanyi.com/video${query}`,
};
